import Mention from '@tiptap/extension-mention';
import { mergeAttributes } from '@tiptap/core';

const visibleMentionText = (label: unknown) => `@${typeof label === 'string' ? label : ''}`;

export const NoteMention = Mention.extend({
    addKeyboardShortcuts() {
        return {
            Backspace: () =>
                this.editor.commands.command(({ state, dispatch }) => {
                    const { empty, $from } = state.selection;

                    if (!empty) {
                        return false;
                    }

                    const mentionNode = $from.nodeBefore;

                    if (mentionNode?.type.name !== this.name) {
                        return false;
                    }

                    dispatch?.(
                        state.tr.insertText(
                            visibleMentionText(mentionNode.attrs.label),
                            $from.pos - mentionNode.nodeSize,
                            $from.pos
                        )
                    );

                    return true;
                }),
        };
    },
}).configure({
    HTMLAttributes: {
        class: 'note-mention',
    },
    renderHTML({ node, options }) {
        return [
            'span',
            mergeAttributes(
                { 'data-type': 'mention', contenteditable: 'false' },
                options.HTMLAttributes,
                {
                    'data-id': node.attrs.id,
                    'data-label': node.attrs.label,
                }
            ),
            visibleMentionText(node.attrs.label),
        ];
    },
    renderText({ node }) {
        return visibleMentionText(node.attrs.label);
    },
});
